import { render } from "./NewLoginPage.vue?vue&type=template&id=0dcb6a76&scoped=true"
import script from "./NewLoginPage.vue?vue&type=script&lang=js"
export * from "./NewLoginPage.vue?vue&type=script&lang=js"

import "./NewLoginPage.vue?vue&type=style&index=0&id=0dcb6a76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcb6a76"]])

export default __exports__